<script>
import FormElement from '@wielink-application/shared/vue/components/form/horizontal/email.vue'

export default FormElement;
</script>